<form class="form-container" [formGroup]="form">
    @if (f['adminStrId'].value != null) {
        <h2 mat-dialog-title>{{'UPDATE_DISTRICT' | translate}}</h2>
    } @else {
        <h2 mat-dialog-title>{{'ADD_DISTRICT' | translate}}</h2>
        }

    <mat-dialog-content class="mat-typography">
        <mat-form-field appearance="outline">
            <mat-label>{{'DIVISION' | translate}}</mat-label>
            <mat-select formControlName="division" size="small" (selectionChange)="onOptionSelected($event)">
                  <!-- Input field for searching -->
                  <input id="search-select" class="w-100 border-0 p-1" (input)="filteredListDivision=onFilteredListSearch($event, divisionList, 'name')"
                  placeholder="Search {{ 'DIVISION' | translate }}" />
                @for (ct of filteredListDivision;track ct) {
                    <mat-option [value]="ct.adminStrId">{{ct.name}}</mat-option>
                }
            </mat-select>
            @if (f['division'].errors) {
                <mat-error>
                    @if (f['division'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                        translate}}</span>}
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'DISTRICT_NAME' | translate}} </mat-label>
            <input matInput formControlName="name">
            @if (f['name'].errors) {
                <mat-error>
                    @if (f['name'].errors['required']) { <span>{{'DISTRICT_NAME_REQUIRED' | translate}}</span>}
                    @if (f['name'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'DESCRIPTION' | translate}} </mat-label>
            <input matInput formControlName="description">
            @if (f['description'].errors) {
                <mat-error>
                    @if (f['description'].errors['required']) { <span>{{'DESCRIPTION_REQUIRED' | translate}}</span>}
                    @if (f['description'].errors['maxlength']) { <span>{{'MAX_LENGTH_300' | translate}}</span>}
                </mat-error>
            }
        </mat-form-field>
        <mat-checkbox formControlName="pulse">PULSE</mat-checkbox>
        <mat-checkbox formControlName="plra">PLRA</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <!-- <div>
            <button mat-raised-button mat-dialog-close class="active-btn">{{'ACTIVATE' | translate}}</button>
            <button mat-raised-button mat-dialog-close class="deactive-btn">{{'DEACTIVATE' | translate}}</button>
        </div> -->
        <div>
            
        @if (f['adminStrId'].value != null) {
            <button mat-button class="btn-primary" [disabled]="form.invalid" (click)="edit()" color="primary"
                    cdkFocusInitial>{{'Save' | translate}} </button>
        } @else {
            <button mat-button class="btn-primary" [disabled]="form.invalid" (click)="add()" color="primary"
                    cdkFocusInitial>{{'Add_BUTTON' | translate}} </button>
        }
        <button mat-button class="btn-secondary" mat-dialog-close>{{'Cancel' | translate}}</button>
    </div>
    </mat-dialog-actions>
</form>